var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-wrap"},[_c('img',{attrs:{"src":require("@/assets/images/index/closed.png")}}),_c('h2',[_vm._v(_vm._s(_vm.siteInfo.close_reason || '网站已关闭'))])])}
var staticRenderFns = []

export { render, staticRenderFns }